"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SvgIcon = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _server = require("react-dom/server");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponent = require("./components/styledComponent.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "width", "height", "fillColor", "strokeColor", "fillHoverColor", "strokeHoverColor", "isInherit", "url", "isHover", "onClick", "isImageData", "strokeWidth", "preserveNoneFill"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace);
};
const SvgIcon = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      children,
      width,
      height,
      fillColor = 'none',
      strokeColor = theme.color.defaultTextColor,
      fillHoverColor,
      strokeHoverColor,
      isInherit = false,
      url,
      isHover: manualHover = false,
      onClick,
      isImageData = false,
      strokeWidth = 1,
      preserveNoneFill = false
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const [isHover, setHover] = (0, _react.useState)(false);
  const isHovered = isHover || manualHover;
  const updateColor = iconStr => {
    const filledColor = (isHovered ? fillHoverColor ?? fillColor : fillColor) ?? 'none';
    const strokedColor = (isHovered ? strokeHoverColor ?? strokeColor : strokeColor) ?? 'none';
    let str = iconStr;
    const widthReg = / width(\s+|)=(\s+|)(\"|\')(.*?)(\"|\')/g;
    if (str.match(widthReg)) {
      if (width !== undefined && width !== '') {
        str = str.replace(widthReg, " width='" + width + "'");
      }
    }
    const heightReg = / height(\s+|)=(\s+|)(\"|\')(.*?)(\"|\')/g;
    if (str.match(heightReg)) {
      if (height !== undefined && height !== '') {
        str = str.replace(heightReg, " height='" + height + "'");
      }
    }
    if (preserveNoneFill) {
      const fillNoneReg = /fill(\s+|)=(\s+|)(\"|\')none(\"|\')/g;
      if (str.match(fillNoneReg) && filledColor !== 'none') {
        str = str.replace(fillNoneReg, `fill='${filledColor}'`);
      }
    }
    const fillReg = /fill(\s+|)=(\s+|)(\"|\')([^none].*?)(\"|\')/g;
    if (str.match(fillReg)) {
      if (filledColor !== undefined && filledColor !== '') {
        str = str.replace(fillReg, "fill='" + filledColor + "'");

        // if (!str.includes('fill=')) {
        // 	str = str.replace(/<svg/, `<svg fill="${filledColor}"`);
        // }
      } else {
        if (isInherit) {
          str = str.replace(fillReg, '');
        }
      }
    } else if (str.indexOf('fill=') === -1) {
      str = str.replace(/<svg/, "$& fill='none'");
    }
    const strokeWidthReg = /stroke-width\s*=\s*(['"])(.*?)\1/g;
    if (str.match(strokeWidthReg)) {
      if (strokeWidth !== undefined && strokeWidth !== '') {
        str = str.replace(strokeWidthReg, `stroke-width='${strokeWidth}'`);
      } else {
        if (isInherit) {
          str = str.replace(strokeWidthReg, '');
        }
      }
    } else if (strokeWidth !== undefined && strokeWidth !== '') {
      str = str.replace(/<svg/, `$& stroke-width='${strokeWidth}'`);
    } else if (str.indexOf('stroke-width=') === -1) {
      str = str.replace(/<svg/, `$& stroke-width='1'`);
    }
    // const strokeWidthReg = /stroke-width\s*=\s*(['"])(.*?)\1/g;

    // if (str.match(strokeWidthReg)) {

    // 	if (strokeWidth !== undefined && strokeWidth !== '') {
    // 		str = str.replace(strokeWidthReg, `stroke-width='${strokeWidth}'`);
    // 	} else {
    // 		if (isInherit) {
    // 			str = str.replace(strokeWidthReg, '');
    // 		}
    // 	}
    // } else if (strokeWidth !== undefined && strokeWidth !== '') {
    // 	str = str.replace(/<svg/, `$& stroke-width='${strokeWidth}'`);
    // }

    const strokeReg = /stroke(\s+|)=(\s+|)(\"|\')([^none].*?)(\"|\')/g;
    if (str.match(strokeReg)) {
      if (strokedColor !== undefined && strokedColor !== '') {
        str = str.replace(strokeReg, "stroke='" + strokedColor + "'");
      } else {
        if (isInherit) {
          str = str.replace(strokeReg, '');
        }
      }
    } else if (strokedColor !== undefined && strokedColor !== '') {
      str = str.replace(/<svg/, `$& stroke='${strokedColor}'`);
    } else if (str.indexOf('stroke=') === -1) {
      str = str.replace(/<svg/, "$& stroke='none'");
    }

    // const strokeReg1 = /stroke\s*=\s*(["'])(.*?)\1/g;

    // if (str.match(strokeReg1) && strokedColor) {
    // 	str = str.replace(strokeReg1, "stroke='" + strokedColor + "'");
    // }

    // const strokeReg = /stroke\s*=\s*(['"])(.*?)\1/g;

    // if (str.match(strokeReg)) {
    // 	// Case 1: stroke already exists
    // 	if (strokedColor !== undefined && strokedColor !== '') {
    // 		// Replace with new color
    // 		str = str.replace(strokeReg, `stroke='${strokedColor}'`);
    // 	} else if (isInherit) {
    // 		// Remove stroke if inherit
    // 		str = str.replace(strokeReg, '');
    // 	}
    // } else if (strokedColor !== undefined && strokedColor !== '') {
    // 	// Case 2: stroke not present, but we have a color
    // 	str = str.replace(/<svg/, `$& stroke='${strokedColor}'`);
    // } else if (str.indexOf('stroke=') === -1) {
    // 	// Case 3: stroke not present, no color → default
    // 	str = str.replace(/<svg/, `$& stroke='none'`);
    // }

    return str;
  };
  if (url) {
    const isInlineSvg = url?.startsWith('<svg');
    if (isInlineSvg) {
      const decoded = url?.startsWith('data:image/svg+xml') ? decodeURIComponent(atob(url?.split(',')[1])) : url;
      const updatedInline = updateColor(decoded);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponent.StyledContainer, Object.assign({
        hoverColor: strokeHoverColor,
        isHover: isHovered,
        className: "mun-svg-container",
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false),
        onClick: onClick
      }, rest, {
        children: [(0, _htmlReactParser.default)(updatedInline), children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponent.StyledContainerText, {
          className: "mun-svg-container__text",
          children: children
        })]
      }));
    }
    let updatedImage = updateColor(decodeURI(url));
    updatedImage = replaceAll(updatedImage, '#', '%23');
    updatedImage = replaceAll(updatedImage, '>', '%3E');
    updatedImage = replaceAll(updatedImage, '<', '%3C');
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponent.StyledContainer, Object.assign({
      hoverColor: strokeHoverColor,
      isHover: isHovered,
      className: "mun-svg-container",
      onMouseEnter: () => {
        setHover(true);
      },
      onMouseLeave: () => setHover(false),
      onClick: onClick
    }, rest, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: isImageData ? url : updatedImage,
        className: "mun-svg-container__icon",
        height: height,
        width: width
      }), children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponent.StyledContainerText, {
        className: "mun-svg-container__text",
        children: children
      })]
    }));
  }
  if (!children) return null;
  let icon = (0, _server.renderToString)(children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _htmlReactParser.default)(updateColor(icon))
  });
};
exports.SvgIcon = SvgIcon;
var _default = exports.default = SvgIcon;